module.exports = __webpack_public_path__ + "static/media/e14.7b55a95b.jpg";